import { pushToDataLayer } from '@almbrand/trackinghooks';
import { PageContext } from 'context/PageContext';
import { useContext, useEffect } from 'react';

/**
 * Custom hook to track page views and time spent on the page.
 *
 * This hook pushes data to the data layer for tracking purposes. It tracks the page section,
 * brand, previous page URL, platform, and full URL. It also tracks page view events and
 * timestamps for time spent on the page.
 *
 * Usage:
 *
 * ```tsx
 * useTrackPage();
 * ```
 */
export const useTrackPage = () => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext ?? {};

	const cleanTheme = theme?.replace('-theme', '');

	useEffect(() => {
		// Push initial page data to the data layer
		pushToDataLayer({
			pageSection: window.location.pathname.startsWith('/erhverv/') ? 'erhverv' : 'privat',
			brand: cleanTheme,
			previousPageUrl: sessionStorage.getItem('previousPageUrl') || '',
			platform: 'web',
			fullUrl: window.location.href,
		});

		// Track pageview event
		pushToDataLayer({
			event: 'trackPageview',
		});

		// Update sessionStorage with the current page URL
		sessionStorage.setItem('previousPageUrl', window.location.href);
	}, []);
};
